<template>
    <div v-if="value" :class="['alert', 'alert-dismissible', getMessageClass()]">
        <span class="close" aria-label="close" v-on:click="onCloseClick">&times;</span>
        <p v-html="value.text"></p>
    </div>
</template>

<script>
    export default {
        name: 'status-message',
        props: {
            value: Object,
        },
        data() {
            return {
                text: this.value
            };
        },
        methods: {
            getMessageClass(){
                switch(this.value.type){
                    case 'error':
                        return 'alert-danger';
                    case 'info':
                        return 'alert-info';
                    case 'success':
                        return 'alert-success';
                    default:
                        return 'alert-info';
                }
            },
            onCloseClick(){
                this.$emit('input', null);
            }
        },
    }
</script>
